var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-contaienr"},[_c('el-result',{staticStyle:{"margin-top":"100px"},attrs:{"icon":"success","title":_vm.id ? '编辑成功' : '创建成功'}},[_c('template',{slot:"extra"},[_c('el-button',{staticClass:"btn-blue",staticStyle:{"margin-top":"50px"},on:{"click":_vm.goto}},[_vm._v("返回")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }